//Primary
const pissYellow = '#ECC417';
const darkGrey = 'var(--color-dark-grey)';
const dark = 'var(--color-dark)';
const white = '#fff';

//Secondary
const green = '#408a4b';
const red = '#D54733';
const blue = '#0e5d9e';
const pink = '#c54357';
const gray = '#3B4155';

//Shades
//dark shades
const charcoalGrey = 'var(--color-charcoalgrey)';
const slateGrey = 'var(--color-slategrey)';

//Yellow Shades

const colors = {
    primary: {
        pissYellow,
        darkGrey,
        dark,
        white
    },
    sec: {
        green,
        red,
        blue,
        pink,
        gray
    }
};

const shades = {
    dark: {
        charcoalGrey,
        slateGrey
    }
};

export {colors, shades};



// WEBPACK FOOTER //
// ./src/utils/colors.js